import React, {useEffect, useRef, useState} from 'react';
import AppBar from "@material-ui/core/AppBar";
import clsx from "clsx";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import MenuIcon from '@material-ui/icons/Menu';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TreeMenu from "../../components/common/TreeMenu";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Avatar from "@material-ui/core/Avatar";
import {useSelector} from "react-redux";
import Box from "@material-ui/core/Box";
import favicon from '../../assets/favicon.ico';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';
import Button from "@material-ui/core/Button";
import {Save} from "@material-ui/icons";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import client from "../../lib/api/client";
import {store} from "react-notifications-component";
import {withRouter} from "react-router-dom";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {useRecoilValue} from "recoil";
import {answerState, familyState, rentState, userState} from "../../state/globalState";

const drawerWidth = 270;

const useStyles = makeStyles(theme => ({
    layout: {
        display: 'block',
        width: 'auto',
        maxWidth: '100%',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2))]: {
            width: 1000,
            marginLeft: 'auto',
            marginRight: 'auto',
        }
    },
    paper: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
        background: 'transparent',
        boxShadow: 'none'
    },
    button: {
        color: "#1b6817",
        background: "#F0EDCC",
        marginLeft: 10
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        })
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        maxWidth: drawerWidth,
        backgroundColor: '#f9fff8'
    },
    drawerHeader: {
        position: 'relative',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        marginTop: -16,
        padding: 10,
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end'
    },
    title: {
        flexGrow: 1,
    },
    loadingSpinner: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        marginLeft: '-50px',
        marginTop: '-50px',
        zIndex: 999
    },
    logout: {
        width: "20px",
        height: "20px",
        marginLeft: "20px"
    },
    confirmContainer: {
        // display: 'flex',
        // justifyContent: 'center',
        // flexDirection: 'column',
        textAlign: 'center',
        borderRadius: '5px',
        padding: '20px 30px',
        backgroundColor: '#ffffff',
        boxShadow: 'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
        width: '100%',
        color: '#161B21'
    },
    confirmButton: {
        width: '160px',
        padding: '10px',
        border: '1px solid #292826',
        margin: '10px',
        cursor: 'pointer',
        background: 'none',
        color: '#292826',
        fontSize: '14px'
    }
}));


const Header = (props) => {
    const userInfo = useRecoilValue(userState);
    const answer = useRecoilValue(answerState);
    const rent = useRecoilValue(rentState);
    const family = useRecoilValue(familyState);
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery('(max-width:800px)');
    const [open, setOpen] = useState(true);
    const isSidebar = props.sidebar;
    const { isProcess } = useSelector(({file}) => ({
        isProcess: file.isProcess
    }));

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (userInfo && userInfo.surveyYn === "0") {
                    console.log('API call executed');
                    await saveTempCont(answer, rent, family); // 최신 상태의 값들을 전달
                }
            } catch (error) {
                // console.error('Error fetching data:', error);
                localStorage.clear();
                window.location.replace("/");
            }
        };

        // 3분(180,000 밀리초)마다 fetchData 함수 실행
        const intervalId = setInterval(() => {
            fetchData();
        }, 3 * 60 * 1000);

        // 컴포넌트가 언마운트될 때 타이머 해제
        return () => {
            clearInterval(intervalId);
        };
    }, [answer, rent, family]); // answer, rent, family가 변경될 때마다 fetchData 재정의

    useEffect(() => {
        if (isSidebar) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [isSidebar]);

    useEffect(() => {
        if (isSidebar && matches) {
            setOpen(false);
        } else if (isSidebar && !matches) {
            setOpen(true);
        }
    }, [matches]);



    const saveTempCont = async (answer, rent, family) => {
        const storeData = {
            answer,
            rent,
            family
        }
        const storeDataString = JSON.stringify(storeData);
        client.post('/kognr/tmpCont', {
            admnNo: userInfo.admnNo,
            kognrTmpCont: storeDataString,
        }).catch((error) => {
            console.log(error.response);
        });

    }
    const handleTmpSave = () => {

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className={classes.confirmContainer}>
                        <h3>임시저장</h3>
                        <p>임시저장을 진행하시겠습니까?</p>
                        <button className="button-cancel" role="button" onClick={onClose}>아니오</button>
                        <button
                            className="button-select"
                            onClick={() => {

                                const storeData = {
                                    answer,
                                    rent,
                                    family
                                }

                                onClose();
                                const storeDataString = JSON.stringify(storeData);
                                // localStorage.setItem("STORE_DATA", storeDataString);
                                client.post('/kognr/tmpCont', {
                                    admnNo: userInfo.admnNo,
                                    kognrTmpCont: storeDataString,
                                }).then(res => {

                                    const { data } = res;
                                    if (data.success) {
                                        console.log("this :", data.payload);
                                        store.addNotification({
                                            title: "알림",
                                            message: "임시저장이 정상 처리되었습니다.",
                                            type: 'success',
                                            insert: "top",
                                            container: "top-center",
                                            animationIn: ["animated", "flipInY"],
                                            animationOut: ["animated", "flipOutY"],
                                            dismiss: {
                                                duration: 3000,
                                                onScreen: false
                                            },
                                            width: 500
                                        });
                                    }

                                }).catch((error) => {
                                    console.log(error.response);
                                });
                            }}
                        >
                            예
                        </button>
                    </div>
                );
            }
        });
    };

    // const handleTmpLoad = () => {
    //     client.post('/api/load/tmp').then(response => {
    //         const storeData = JSON.parse(response.data.STORE_DATA);
    //         dispatch(setSurveyData(storeData.survey.survey));
    //         dispatch(setMenuData(storeData.menu.menu));
    //         dispatch(loadAnswer(storeData.answers));
    //         dispatch(loadFamily(storeData.family));
    //     }).catch((error) => {
    //         console.log(error.response);
    //     });
    // };

    const handleDrawerOpen = () => {
        if (props.sidebar) {
            setOpen(true);
        }
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    // 로그아웃
    const handleLogoutButtonClick = () => {
        client.post('/kognr/logout').then(response => {
            if (response.data.success) {
                localStorage.clear();
                window.location.replace("/");
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    return (
        <>
            <Loader
                className={classes.loadingSpinner}
                type="ThreeDots"
                color="#db641a"
                height={100}
                width={100}
                visible={isProcess}
            />
            <AppBar
                position="fixed"
                style={{
                    backgroundColor: '#1b6817',
                    display: isSidebar ? 'display' : 'none'
                }}
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, open && classes.hide)}
                    >
                        <MenuIcon />
                    </IconButton>

                    <Typography variant="h6" className={classes.title}>
                        <Avatar alt="ey" variant="square" src={favicon} />
                    </Typography>
                    { matches ?
                        <Typography variant="subtitle2" className={classes.title}>
                            <Box fontWeight="fontWeightBold">
                                {userInfo.stdYear}년 귀속 종합소득세 신고 질문지
                            </Box>
                        </Typography>
                        :
                        <Typography variant="h6" className={classes.title}>
                            {userInfo.stdYear}년 귀속 종합소득세 신고 질문지
                        </Typography>
                    }

                    {userInfo.surveyYn === "0" && (
                        <Button
                            className={classes.button}
                            variant="contained"
                            onClick={handleTmpSave}
                            startIcon={<Save fontSize="small" />}
                        >
                            임시저장
                        </Button>
                    )}

                    <Button
                        className={classes.button}
                        variant="contained"
                        onClick={handleLogoutButtonClick}
                        startIcon={<ExitToAppIcon fontSize="small" />}
                    >
                        로그아웃
                    </Button>
                </Toolbar>
            </AppBar>

            <Drawer
                className={classes.drawer}
                variant="persistent"
                anchor="left"
                open={open}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div style={{height: '52px'}}>
                    <span style={{fontFamily: 'Noto Sans KR', fontStyle: 'normal', fontWeight: 'bold', fontSize: '12px',
                        color: '#1b6817', position: 'absolute', left: '25px', top: '20px'}}>진행현황</span>
                    <div className={classes.drawerHeader}>
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'ltr' ? <ChevronLeftIcon color='#1b6817' /> : <ChevronRightIcon />}
                        </IconButton>
                    </div>
                </div>
                <Divider />
                <TreeMenu isTmpCont={props.isTmpCont} />
            </Drawer>

            <Grid container className="survey-container">
                <Grid container
                      spacing={2}
                      direction="column"
                      alignItems="center"
                      style={{ minHeight: '100vh', paddingLeft: open? 270 : 0}}
                >
                    <div className={classes.layout}>
                        <Paper className={classes.paper}>
                            {props.children}
                        </Paper>
                    </div>
                </Grid>
            </Grid>
        </>
    )
};

export default withRouter(Header);

